import React, { useState } from 'react';
import Dialog from "@shared/ui/molecules/Dialog";
import { closeDialog } from '@shared/store/dialog.duck';
import { useDispatch, useSelector } from "react-redux";
import { WeeklyNotesView } from "./components/WeeklyNotesView";
import { SetWeeklyNote } from "./components/SetWeeklyNote";
import { selectCurrentUser } from '@shared/store/auth.duck';
import styled from "styled-components";

enum WeeklyNotesMode {
  View, Edit
}

export function WeeklyNotesDialog(props: Props) {
  const dispatch = useDispatch();
  const [mode, setMode] = useState(WeeklyNotesMode.View);
  const currentUser = useSelector(selectCurrentUser);

  const close = () => {
    dispatch(closeDialog());
  };

  return (
    <WeeklyNotesDialogWrapper>
      <Dialog isOpen={true} onClose={close} headerTitle={'dialog.week-notes'}>

        {mode === WeeklyNotesMode.View && props?.payload?.scope && props?.payload?.date && <WeeklyNotesView scopes={[props.payload.scope]}
                                                                                                            date={props.payload.date}
                                                                                                            onEditClick={() => setMode(WeeklyNotesMode.Edit)} />}

        {mode === WeeklyNotesMode.Edit && props?.payload?.date && currentUser?.id && <SetWeeklyNote date={props.payload.date}
                                                                                                    userId={currentUser.id}
                                                                                                    done={() => setMode(WeeklyNotesMode.View)} />}

      </Dialog>
    </WeeklyNotesDialogWrapper>
  )
}

interface Props {
  payload?: any;
}

const WeeklyNotesDialogWrapper = styled.div`
  .dialog {
    max-width: 100%;
    width: 860px;
  }
  .dialog__content {
    width: 100%;
    padding: 24px;
    margin: unset;
    max-width: 100%;
  }
`
